import cloneDeep from 'lodash/cloneDeep';
import { CategoryStep } from './CategoryStep';
import { PreWorkUIConfig } from '../../../shared/CategoryStepUIConfig';
import { usePreWorkWizard } from './usePreWorkWizard';
import usePreWorkFormHandling from './usePreWorkFormHandling';
import { Divider, Form, Typography } from 'antd';
import { PreWorkStepType } from './PreWorkStepType';
import { PreWorkQuestionId } from '../../../shared/Constants';
import { useCallback, useMemo } from 'react';
import { AnswerOptionUIConfig } from '../../../shared/MultipleChoiceQuestionUIConfig';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const UiConfig = PreWorkUIConfig;

export const PreWorkStep = () => {
	const { t } = useTranslation();
	const clonedUiConfig = useMemo(() => {
		return cloneDeep(UiConfig);
	}, []);

	const { preWorkCategoryAnswers, setPreWorkCategoryAnswers } =
		usePreWorkWizard();

	const { form, updateFieldValue } = usePreWorkFormHandling(
		preWorkCategoryAnswers,
		setPreWorkCategoryAnswers
	);

	const values = Form.useWatch<PreWorkStepType>([], form);
	const { setFieldValue } = form;
	const candidateViewQuestionId =
		PreWorkQuestionId.CANDIDATE_VIEW_ON_COMPLETION;

	const clearCandidateViewAnswer = useCallback(() => {
		setFieldValue(candidateViewQuestionId, {
			selectedOption: undefined,
		});
	}, [candidateViewQuestionId, setFieldValue]);

	const updatedUiConfig = {
		...clonedUiConfig,
		questions: clonedUiConfig.questions.map((question) => {
			if (
				question.questionId !==
					PreWorkQuestionId.CANDIDATE_VIEW_ON_COMPLETION ||
				!values
			) {
				return question;
			}

			const systemGeneratedOption =
				values[`${PreWorkQuestionId.SYSTEM_GENERATED}`]?.selectedOption;
			const candidateSelectedFirstOption =
				values[candidateViewQuestionId].selectedOption === 1;
			const candidateSelectedSecondOption =
				values[candidateViewQuestionId].selectedOption === 2;
			const candidateSelectedThirdOption =
				values[candidateViewQuestionId].selectedOption === 3;
			const candidateSelectedFourthOption =
				values[candidateViewQuestionId].selectedOption === 4;
			const candidateSelectedFifthOption =
				values[candidateViewQuestionId].selectedOption === 5;
			let validOptions: AnswerOptionUIConfig[] = [];

			switch (systemGeneratedOption) {
				case 1:
					if (
						candidateSelectedThirdOption ||
						candidateSelectedFourthOption ||
						candidateSelectedFifthOption
					) {
						clearCandidateViewAnswer();
					}
					validOptions = [
						{ optionId: 1, optionText: 'completedPreWork' },
						{ optionId: 2, optionText: 'completedPreWorkBut' },
					];
					break;

				case 2:
					if (candidateSelectedFirstOption) {
						clearCandidateViewAnswer();
					}
					validOptions = [
						{ optionId: 2, optionText: 'completedPreWorkBut' },
						{ optionId: 3, optionText: 'partiallyCompletedPreWork' },
					];
					break;

				case 3:
					if (candidateSelectedFirstOption || candidateSelectedSecondOption) {
						clearCandidateViewAnswer();
					}
					validOptions = [
						{ optionId: 3, optionText: 'partiallyCompletedPreWork' },
					];
					break;

				default:
					break;
			}

			return {
				...question,
				answerOptions: validOptions,
			};
		}),
	};

	return (
		<>
			<div className="flex flex-col">
				<Text className="font-sans font-semibold text-lg text-secondary-black text-center mt-3">
					{t('preworkConfirmationQuestions')}
				</Text>
			</div>
			<Divider className="border border-solid border-gray-200" />
			<CategoryStep
				uiConfig={updatedUiConfig}
				form={form}
				updateFieldValue={updateFieldValue}
			/>
		</>
	);
};
